<template>
  <div>
    
    <AppRow
      v-if="def && !def.componentPath"
      class="ma-0 overflow-hidden"
    >
      <AppColumn
        :cols="12"
        :lg="(def.sideSectionVisible === undefined || def.sideSectionVisible) ? 10 : 12"
        class="pa-0"
      >
        <v-card
          ref="section_container"
          flat
          dir="ltr"
          class="overflow-y-auto overflow-x-hidden"
          :class="def.form.pages.length > 1 ? 'page_height_with_tabs' : 'page_height'"
          style="border-left: solid 1px #d6d6d6 !important;border-radius: 0"
          @scroll="scrollTo"
        >
          <abr-form-section
            v-for="section in def.sections && def.sections.filter(s => !s.portalTo)"
            :id="section.id"
            :key="section.id"
            :ref="section.id"
            dir="rtl"
            :def="{ page: def, ...section }"
            :model="Model"
            :modal="modal"
            class="section1"
          >
            {{ section.name }}
          </abr-form-section>
          <AppPortalTarget 
            :name="def.id"
          >
          </AppPortalTarget>
          <AppPortal 
            v-for="section in def.sections && def.sections.filter(s => s.portalTo)"
            :key="section.id"
            :to="section.portalTo"
          >
            <abr-form-section
              :id="section.id"
              :key="section.id"
              :ref="section.id"
              dir="rtl"
              :def="{ page: def, ...section }"
              :model="Model"
              :modal="modal"
              class="section1"
            >
              {{ section.name }}
            </abr-form-section>
          </AppPortal>
        </v-card>
      </AppColumn>
      <AppColumn
        v-if="
          (def.sideSectionVisible === undefined || def.sideSectionVisible)
        "
        class="d-sm-none d-lg-block"
        style="padding : 12px 12px 12px 0px"
        cols="2"
      >
        <AbrFormPageSideSection 
          :def="def"
          :model="model"
        />
      </AppColumn>
    </AppRow>
  </div>
</template>

<script>
import AbrFormSection from "./AbrFormSection";
import AppRow from "@/components/library/container/AppRow";
import AppColumn from "@/components/library/container/AppColumn";
import AbrFormPageSideSection from "@/components/form/AbrFormPageSideSection"
import AppPortalTarget from "@/components/library/portal/AppPortalTarget"
import AppPortal from "@/components/library/portal/AppPortal"

export default {
  name: "AbrFormPage",
  components: {
    AppColumn,
    AppRow,
    AbrFormSection,
    AbrFormPageSideSection,
    AppPortalTarget,AppPortal
  },
  props: ["def", "model", "modal"],
  data: vm => ({
    clear: null,
    Model: vm.model,
    selected: 0,
    activeTab: JSON.parse(JSON.stringify(vm.$store.state.tabManagement.activeTab)),
  }),
  mounted() {
    this.canScroll = true;
    // setTimeout(() => {
    //   const { pageForm, modalForm, pagesScrollPos } = this.$store.state.tabManagement.tabs[this.activeTab];
    //   if(pageForm?.show || modalForm?.show) return;
    //   const { $el } = this.$refs["section_container"];
    //   $el.scrollTo({
    //     left: 0,
    //     top: pagesScrollPos[this.def.name],
    //     behavior: "smooth"
    //   });
    // }, 10);
    this.$eventBus.$on('PageScrollToPos' , payload => {
      this.$nextTick(() => {
        this.$refs[payload] && this.$refs[payload][0].$el.scrollIntoView({ behavior: "smooth" });
      });
    })

  },
  beforeDestroy(){
    this.$eventBus.$off(`${this.def.id}-SideSectionScrollPos`)
  },
  methods: {
    scrollTo({ target }) {
      // const activeTab = this.$store.state.tabManagement.tabs[this.$store.state.tabManagement.activeTab];
      // Object.assign(activeTab.pagesScrollPos, { [this.def.name]: target.scrollTop })
      if (!this.canScroll) return;
      const refs = this.$refs;
      let arr = [];
      for (let i in refs) arr.push(refs[i][0]);
      for (let i in arr) {
        if(!arr[i]) continue;
        arr[i] = arr[i].$el;
        if ((target.scrollHeight - (target.offsetHeight + target.scrollTop) < 50 || target.scrollTop > (arr[i].offsetTop - 150) && arr[i].offsetTop + arr[i].offsetHeight - 150 > target.scrollTop)) {
          const links = document.querySelectorAll(`.${this.def.name}-side-menu-form`);
          links.forEach((link, index) => {
            if (link.id === arr[i].id)
              this.$eventBus.$emit(`${this.def.id}-SideSectionScrollPos`, index);
          });
        }
      }
    },

  }
};
</script>
<style>
.sideBar{
  font-size: 12px !important;
  font-family: "IranYekanLight";
  font-weight: bold;
  /*line-height: 21px;*/
  text-align: right;
  height: 32px!important;

}
.section1{
  border-top: solid 1px rgba(224, 224, 224, 1);
  border-radius: 0;
  border-collapse: collapse;
}

.section1:first-child{
  border-top:none;
}
.page_height{
  height: 75.4vh;
}
.page_height_with_tabs{
  height: 70.5vh;
}
.v-stepper__items .page_height_with_tabs {
  height: 68.2vh
}
.v-dialog__content .v-stepper__items .page_height_with_tabs {
  height: 66.2vh
}
</style>
